// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.TableViewPopup_dashboard__Bk8Cv {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.TableViewPopup_cont2__WSly8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.TableViewPopup_bodythemelight__fp7qv {
  background-color: #f3f6f9;
}

.TableViewPopup_bodythemedark__eT38U {
  background-color: #151521;
}

.TableViewPopup_headerthemelight__Jza1g {
  background-color: #fff;
}

.TableViewPopup_headerthemedark__LXffa {
  background-color: #151521;
}

.TableViewPopup_menuthemelight__LhB3c {
  background-color: #fff;
}

.TableViewPopup_menuthemedark__kDS-2 {
  background-color: #151521;
}

.TableViewPopup_menulinklight__X6MCA {
  color: #60677e !important;
}

.TableViewPopup_menulinklightSelected__QmHyj {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.TableViewPopup_menulinkdarkSelected__O\\+6\\+L {
  color: #fff !important;
  border-radius: 10px;
}

.TableViewPopup_menulinkdark__0CoHZ {
  color: #60677e !important;
}

.TableViewPopup_menulinklight__X6MCA:hover {
  color: #1d1d1d !important;
}

.TableViewPopup_menulinkdark__0CoHZ:hover {
  color: #fff !important;
}

.TableViewPopup_headinglight__X-ybd {
  color: #60677e;
}

.TableViewPopup_headingdark__K-CKc {
  color: #60677e;
}

.TableViewPopup_searchboxlight__IW4y0 {
  background-color: #fff;
  border: none;
}

.TableViewPopup_searchboxdark__yI0sj {
  background-color: #1e1e2d;
  color: #60677e;
}

.TableViewPopup_searchboxdark__yI0sj::placeholder {
  color: #60677e;
}

.TableViewPopup_tableheadlight__fLoF6 {
  background-color: #e9eaf0;
}

.TableViewPopup_tableheaddark__ByeKf {
  background-color: #1e1e2d;
  color: #60677e;
}

.TableViewPopup_tablebodylight__eYYYF {
  background-color: #fff;
}
.TableViewPopup_tablebodylight__eYYYF:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.TableViewPopup_tablebodydark__jZy-n {
  background-color: #1e1e2d;
  color: #60677e;
}
.TableViewPopup_tablebodydark__jZy-n:hover {
  background-color: #252530;
  cursor: pointer;
}

.TableViewPopup_paginationlight__x\\+QwH {
  color: #60677e !important;
  font-size: 13px !important;
}

.TableViewPopup_paginationdark__jrN5e {
  color: #60677e !important;
  font-size: 13px !important;
}

.TableViewPopup_formthemelight__9E6G5 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.TableViewPopup_formthemedark__SEbrt {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.TableViewPopup_formthemedark__SEbrt ::placeholder {
  color: #60677e;
}

.TableViewPopup_viewformlight__pK93I {
  background-color: #f3f6f9;
}

.TableViewPopup_viewformdark__D970- {
  background-color: #151521;
}

.TableViewPopup_permissionboxlight__omoDD {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.TableViewPopup_permissionboxdark__dI-1S {
  background-color: #151521;
  border: none;
}

.TableViewPopup_errormsgclr__40cyw {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.TableViewPopup_graphclrlight__SG\\+F5 {
  background-color: #fff;
}

.TableViewPopup_graphclrdark__TCTv8 {
  background-color: #1e1e2d;
}

#TableViewPopup_card1bglight__xbpCL {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#TableViewPopup_card1bgdark__Q9o0M {
  background: #392f28;
}

#TableViewPopup_card2bglight__qvHLE {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#TableViewPopup_card2bgdark__fuIJ1 {
  background: #1c3238;
}

#TableViewPopup_card3bglight__ybE2T {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#TableViewPopup_card3bgdark__UNBgK {
  background: #3a2434;
}

#TableViewPopup_card4bglight__TKUGy {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#TableViewPopup_card4bgdark__1QTv4 {
  background: #2f264f;
}

.TableViewPopup_actionbtnlight__gwhXA {
  color: rgba(70, 71, 91, 0.8705882353);
}

.TableViewPopup_actionbtndark__a9GeW {
  color: #60677e;
}

.TableViewPopup_profiledropdownlight__Ky5fH {
  background-color: #fff;
}

.TableViewPopup_profiledropdowndark__0TwsG {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .TableViewPopup_cont2__WSly8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
/* Popup style */
.TableViewPopup_popupbox__a0ady {
  position: fixed;
  background: rgba(0, 0, 0, 0.46);
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 99;
}

#TableViewPopup_box__2aK4E {
  position: relative;
  width: 55%;
  margin: 0 auto;
  height: auto;
  max-height: 70vh;
  margin-top: calc(30vh - 20px);
  border-radius: 4px;
  padding: 20px;
  overflow: auto;
}

.TableViewPopup_closeicon__xX-PQ {
  content: "x";
  cursor: pointer;
  position: fixed;
  right: calc(22% - 18px);
  top: calc(27vh - 25px);
  background: #ededed;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
  border: 1px solid #999;
  font-size: 20px;
}

#TableViewPopup_addheading__L0Wjm {
  font-size: 20px;
  font-family: "SFUIDisplay-Medium";
}

.TableViewPopup_nametitle__1BORB {
  font-size: 16px;
  font-family: "SFUIDisplayRegular";
}

.TableViewPopup_name__d-fY- {
  font-size: 16px;
  color: #fff;
  font-family: "SFUIDisplayRegular";
}

.TableViewPopup_detailsdiv__v6KtY {
  padding: 5px;
  background-color: #fff;
}

.TableViewPopup_profilepicdiv__JsY9Q {
  border-radius: 5px;
}

.TableViewPopup_profile_imgsection__Tz7nf {
  display: flex;
  justify-content: center;
  align-items: center;
}

.TableViewPopup_profilepic__igUKH {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid rgba(33, 37, 41, 0.4588235294);
  padding: 5px;
}

.TableViewPopup_namesection__jDhA7 {
  text-align: center;
}

#TableViewPopup_profilename__xS1eF {
  font-size: 14px;
  font-family: "SFUIDisplay-Medium";
  margin-top: 30px;
  text-align: center;
}

.TableViewPopup_profileemail__sIv64 {
  font-size: 12px;
  font-family: "SFUIDisplayRegular";
}

#TableViewPopup_profiledob__CoUKF {
  font-size: 12px;
  font-family: "SFUIDisplayRegular";
}

#TableViewPopup_empdiv__2\\+KYM {
  padding: 5px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_title__QI5k1 {
  font-family: "SFUIDisplayRegular";
  font-size: 13px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_empname__cUDDH {
  font-family: "SFUIDisplay-Medium";
  font-size: 14px;
  padding-bottom: 8px;
  word-break: break-word;
}

@media only screen and (max-width: 400px) {
  #TableViewPopup_box__2aK4E {
    width: 80%;
    margin: 90px 40px;
  }
  .TableViewPopup_closeicon__xX-PQ {
    right: calc(32% - 64px);
    top: calc(23vh - 25px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/TableViewPopup/TableViewPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AAjQA,gBAAA;AACA;EACI,eAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAmQJ;;AAhQE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAmQJ;;AAhQE;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAmQJ;;AA/PE;EACE,eAAA;EACA,iCDiCY;ACiOhB;;AA/PA;EACI,eAAA;EACA,iCD6Ba;ACqOjB;;AAhQA;EACI,eAAA;EACA,WDUU;ECTV,iCDwBa;AC2OjB;;AAjQA;EACI,YAAA;EACA,sBDKU;AC+Pd;;AAjQA;EAEI,kBAAA;AAmQJ;;AAhQA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAmQJ;;AAhQA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;AAmQJ;;AAhQA;EACI,kBAAA;AAmQJ;;AAhQA;EACI,eAAA;EACA,iCDTY;ECUZ,gBAAA;EACA,kBAAA;AAmQJ;;AAjQA;EACI,eAAA;EACA,iCDda;ACkRjB;;AAlQA;EACI,eAAA;EACA,iCDlBa;ACuRjB;;AAlQA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AAqQJ;AAnQI;EACI,iCD3BS;EC4BT,eAAA;AAqQR;AAlQI;EACI,iCDjCQ;ECkCR,eAAA;EACA,mBAAA;EACA,sBAAA;AAoQR;;AA9PA;EACI;IACI,UAAA;IACA,iBAAA;EAiQN;EA9PI;IACE,uBAAA;IACA,sBAAA;EAgQN;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n/* Popup style */\n.popupbox {\n    position: fixed;\n    background: rgb(0 0 0 / 46%);\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 99 ;\n  }\n   \n  #box {\n    position: relative;\n    width: 55%;\n    margin: 0 auto;\n    height: auto;\n    max-height: 70vh;\n    margin-top: calc(100vh - 70vh - 20px);\n    border-radius: 4px;\n    padding: 20px;\n    overflow: auto;\n  }\n   \n  .closeicon {\n    content: 'x';\n    cursor: pointer;\n    position: fixed;\n    right: calc(22% - 18px);\n    top: calc(100vh - 73vh - 25px);\n    background: #ededed;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    line-height: 20px;\n    text-align: center;\n    border: 1px solid #999;\n    font-size: 20px;\n  }\n  \n\n  #addheading{\n    font-size: 20px;\n    font-family: $sffont-medium;\n}\n\n.nametitle{\n    font-size: 16px;\n    font-family: $sffont-regular;\n}\n.name{\n    font-size: 16px;\n    color: $white-color;\n    font-family: $sffont-regular;\n}\n.detailsdiv{\n    padding: 5px;\n    background-color: $white-color;\n}\n\n.profilepicdiv{\n    // padding: 10px;\n    border-radius: 5px;\n}\n\n.profile_imgsection{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profilepic{\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 1px solid #21252975;\n    padding: 5px;\n}\n\n.namesection{\n    text-align: center;\n}\n\n#profilename{\n    font-size: 14px;\n    font-family: $sffont-medium;\n    margin-top: 30px;\n    text-align: center;\n}\n.profileemail{\n    font-size: 12px;\n    font-family: $sffont-regular;\n}\n#profiledob{\n    font-size: 12px;\n    font-family: $sffont-regular;\n}\n\n#empdiv{\n    padding:5px 0px 0px 15px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n\n    .title{\n        font-family: $sffont-regular;\n        font-size: 13px;\n    }\n\n    .empname{\n        font-family: $sffont-medium;\n        font-size: 14px;\n        padding-bottom:8px;\n        word-break: break-word;\n    }\n}\n\n\n\n@media only screen and (max-width: 400px) {\n    #box {\n        width: 80%;\n        margin: 90px 40px;\n      }\n\n      .closeicon {\n        right: calc(32% - 64px);\n        top: calc(23vh - 25px);\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `TableViewPopup_dashboard__Bk8Cv`,
	"cont2": `TableViewPopup_cont2__WSly8`,
	"bodythemelight": `TableViewPopup_bodythemelight__fp7qv`,
	"bodythemedark": `TableViewPopup_bodythemedark__eT38U`,
	"headerthemelight": `TableViewPopup_headerthemelight__Jza1g`,
	"headerthemedark": `TableViewPopup_headerthemedark__LXffa`,
	"menuthemelight": `TableViewPopup_menuthemelight__LhB3c`,
	"menuthemedark": `TableViewPopup_menuthemedark__kDS-2`,
	"menulinklight": `TableViewPopup_menulinklight__X6MCA`,
	"menulinklightSelected": `TableViewPopup_menulinklightSelected__QmHyj`,
	"menulinkdarkSelected": `TableViewPopup_menulinkdarkSelected__O+6+L`,
	"menulinkdark": `TableViewPopup_menulinkdark__0CoHZ`,
	"headinglight": `TableViewPopup_headinglight__X-ybd`,
	"headingdark": `TableViewPopup_headingdark__K-CKc`,
	"searchboxlight": `TableViewPopup_searchboxlight__IW4y0`,
	"searchboxdark": `TableViewPopup_searchboxdark__yI0sj`,
	"tableheadlight": `TableViewPopup_tableheadlight__fLoF6`,
	"tableheaddark": `TableViewPopup_tableheaddark__ByeKf`,
	"tablebodylight": `TableViewPopup_tablebodylight__eYYYF`,
	"tablebodydark": `TableViewPopup_tablebodydark__jZy-n`,
	"paginationlight": `TableViewPopup_paginationlight__x+QwH`,
	"paginationdark": `TableViewPopup_paginationdark__jrN5e`,
	"formthemelight": `TableViewPopup_formthemelight__9E6G5`,
	"formthemedark": `TableViewPopup_formthemedark__SEbrt`,
	"viewformlight": `TableViewPopup_viewformlight__pK93I`,
	"viewformdark": `TableViewPopup_viewformdark__D970-`,
	"permissionboxlight": `TableViewPopup_permissionboxlight__omoDD`,
	"permissionboxdark": `TableViewPopup_permissionboxdark__dI-1S`,
	"errormsgclr": `TableViewPopup_errormsgclr__40cyw`,
	"graphclrlight": `TableViewPopup_graphclrlight__SG+F5`,
	"graphclrdark": `TableViewPopup_graphclrdark__TCTv8`,
	"card1bglight": `TableViewPopup_card1bglight__xbpCL`,
	"card1bgdark": `TableViewPopup_card1bgdark__Q9o0M`,
	"card2bglight": `TableViewPopup_card2bglight__qvHLE`,
	"card2bgdark": `TableViewPopup_card2bgdark__fuIJ1`,
	"card3bglight": `TableViewPopup_card3bglight__ybE2T`,
	"card3bgdark": `TableViewPopup_card3bgdark__UNBgK`,
	"card4bglight": `TableViewPopup_card4bglight__TKUGy`,
	"card4bgdark": `TableViewPopup_card4bgdark__1QTv4`,
	"actionbtnlight": `TableViewPopup_actionbtnlight__gwhXA`,
	"actionbtndark": `TableViewPopup_actionbtndark__a9GeW`,
	"profiledropdownlight": `TableViewPopup_profiledropdownlight__Ky5fH`,
	"profiledropdowndark": `TableViewPopup_profiledropdowndark__0TwsG`,
	"popupbox": `TableViewPopup_popupbox__a0ady`,
	"box": `TableViewPopup_box__2aK4E`,
	"closeicon": `TableViewPopup_closeicon__xX-PQ`,
	"addheading": `TableViewPopup_addheading__L0Wjm`,
	"nametitle": `TableViewPopup_nametitle__1BORB`,
	"name": `TableViewPopup_name__d-fY-`,
	"detailsdiv": `TableViewPopup_detailsdiv__v6KtY`,
	"profilepicdiv": `TableViewPopup_profilepicdiv__JsY9Q`,
	"profile_imgsection": `TableViewPopup_profile_imgsection__Tz7nf`,
	"profilepic": `TableViewPopup_profilepic__igUKH`,
	"namesection": `TableViewPopup_namesection__jDhA7`,
	"profilename": `TableViewPopup_profilename__xS1eF`,
	"profileemail": `TableViewPopup_profileemail__sIv64`,
	"profiledob": `TableViewPopup_profiledob__CoUKF`,
	"empdiv": `TableViewPopup_empdiv__2+KYM`,
	"title": `TableViewPopup_title__QI5k1`,
	"empname": `TableViewPopup_empname__cUDDH`
};
export default ___CSS_LOADER_EXPORT___;
